import { MDSButton } from "@/mds";
import {
  AudioRecordingCard,
  AudioRecordingCardBody,
  AudioRecordingCardHeader,
  AudioRecordingCardLabel,
} from "@/pages/audio-recordings/shared/audio-recording-card";
import styled from "@emotion/styled";

export type UploadProcessingCardProps = {
  canUpload: boolean;
  canTransform: boolean;
  onUpload: () => void;
  onTransform: () => void;
  uploadLabel?: string;
  transformLabel?: string;
};

export const UploadProcessingCard = ({
  canUpload,
  canTransform,
  onUpload,
  onTransform,
  uploadLabel = "Trigger Upload",
  transformLabel = "Trigger Transform",
}: UploadProcessingCardProps) => {
  return (
    <AudioRecordingCard>
      <AudioRecordingCardHeader title="Upload & Processing" />
      <AudioRecordingCardBody>
        <AudioRecordingCardLabel>Actions</AudioRecordingCardLabel>
        <ButtonRow>
          <MDSButton onClick={onUpload} isDisabled={!canUpload}>
            {uploadLabel}
          </MDSButton>
          <MDSButton onClick={onTransform} isDisabled={!canTransform}>
            {transformLabel}
          </MDSButton>
        </ButtonRow>
      </AudioRecordingCardBody>
    </AudioRecordingCard>
  );
};

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
